import { JSX, FC } from "react";
import ConfirmModal from "components/ui/modals/ConfirmModal/ConfirmModal";
import InfoCard from "components/ui/InfoCard/InfoCard";

interface IUploadedProductsModalsProps {
  isLoading: boolean;
  confirmText: string;
  isShowDeleteModal: boolean;
  isShowCreateCopyModal: boolean;
  onOkDeleteModal: () => void;
  closeDeleteModal: () => void;
  closeCreateCopyModal: () => void;
}

const UploadedProductsModals: FC<IUploadedProductsModalsProps> = ({
  isLoading,
  confirmText,
  isShowDeleteModal,
  isShowCreateCopyModal,
  onOkDeleteModal,
  closeDeleteModal,
  closeCreateCopyModal,
}): JSX.Element => {
  return (
    <>
      {isShowDeleteModal && (
        <ConfirmModal
          text={confirmText}
          isOpen={isShowDeleteModal}
          onCancelHandler={closeDeleteModal}
          onOkHandler={onOkDeleteModal}
        />
      )}
      {isShowCreateCopyModal && (
        <ConfirmModal
          text="Вы уверены, что хотите создать копию товара?"
          isOpen={isShowCreateCopyModal}
          isApplyDisabled={isLoading}
          onCancelHandler={closeCreateCopyModal}
          onOkHandler={() => { }}
        >
          <InfoCard
            className="px-3 py-2"
            icon={{ type: "exclamation", className: "mr-2" }}
            background="grey"
            text={{ content: "В начало наименования скопированного товара будет добавлена приписка “Копия”" }}
          />
        </ConfirmModal>
      )}
    </>
  );
};

export default UploadedProductsModals;
